export default "__VITE_ASSET__9b1fi1pk__"